import { DocumentNode } from "graphql";
import gql from "graphql-tag";

import { TDeepPartial } from "../../types/helpers";
import { BaseApi } from "../base";
import { TEmailFollowUpConfig } from "../user-settings/types";
import { TOrganizationSettingsMain } from "./types";

export class OrganizationSettingsApi extends BaseApi {
  async getMainSettings(options?: { useCache?: boolean }): Promise<TOrganizationSettingsMain> {
    type TData = {
      momentum: { organization: { settings: { settings: TOrganizationSettingsMain } } };
    };
    const query: DocumentNode = gql`
      query GetOrganizationSettingsMain {
        momentum {
          organization {
            settings {
              settings
            }
          }
        }
      }
    `;

    try {
      const result: TData = await this.query<TData, null>(query, null, {
        fetchPolicy: options?.useCache ? "cache-first" : "network-only",
      });
      return result.momentum.organization.settings.settings;
    } catch (error) {
      this.handleError(error);
    }
  }

  async updateMainSettings(
    updatedSettings: TDeepPartial<TOrganizationSettingsMain>
  ): Promise<TOrganizationSettingsMain> {
    type TVariables = { updatedSettings: TDeepPartial<TOrganizationSettingsMain> };
    type TData = { momentum: { organization: { updateSettings: { settings: TOrganizationSettingsMain } } } };

    const mutation: DocumentNode = gql`
      mutation UpdateOrganizationSettingsMain($updatedSettings: TGqlUpdateOrganizationSettingsInput!) {
        momentum {
          organization {
            updateSettings(input: $updatedSettings) {
              settings
            }
          }
        }
      }
    `;

    try {
      const result: TData = await this.mutate<TData, TVariables>(mutation, { updatedSettings });
      return result.momentum.organization.updateSettings.settings;
    } catch (error) {
      this.handleError(error);
    }
  }

  async getEmailGeneratedSettings(): Promise<TEmailFollowUpConfig> {
    type TData = {
      momentum: { organization: { settings: { emailGenerated: TEmailFollowUpConfig } } };
    };
    const query: DocumentNode = gql`
      query GetOrganizationSettingsEmailGenerated {
        momentum {
          organization {
            settings {
              emailGenerated
            }
          }
        }
      }
    `;

    try {
      const result: TData = await this.query<TData, null>(query);
      return result.momentum.organization.settings.emailGenerated;
    } catch (error) {
      this.handleError(error);
    }
  }

  async updateEmailGeneratedSettings(input: TDeepPartial<TEmailFollowUpConfig>): Promise<boolean> {
    type TVariables = { input: TDeepPartial<TEmailFollowUpConfig> };
    type TData = { momentum: { organization: { updateEmailGeneratedSettings: { updated: boolean } } } };
    const mutation: DocumentNode = gql`
      mutation UpdateOrganizationSettingsEmailGenerated($input: TGqlUpdateEmailGeneratedSettingsInput!) {
        momentum {
          organization {
            updateEmailGeneratedSettings(input: $input) {
              updated
            }
          }
        }
      }
    `;
    try {
      const result: TData = await this.mutate<TData, TVariables>(mutation, { input });
      return result.momentum.organization.updateEmailGeneratedSettings.updated;
    } catch (error) {
      this.handleError(error);
    }
  }
}
